import React, { useEffect, useRef } from "react";
import { TrackControl } from "./TrackControl";
import { RydMixer } from "../../audio/mixer";
import { useMixerStore } from "../../stores/MixerStore";
import './RydAudioMixer.css';
import { VolumeMeter } from "./VolumeMeter";
import { RydInstrument } from "../../model/instrument";
import { TrackColor } from "../../render/trackColor";


type RydMixerProps = {
    tracks: (RydMixer.TrackParams & {
        trackColor: TrackColor.Color,
        output?: RydInstrument
    })[],
    onUpdate: (id: number, changes: Partial<RydMixer.TrackParams>) => void,
    onUpdateMaster: (changes: Partial<RydMixer.TrackParams>) => void,
};

export function RydAudioMixer({
    tracks,
    onUpdate,
    onUpdateMaster
}: RydMixerProps) {

    const mixerStore = useMixerStore();
    const mixer = useRef(mixerStore.mixer).current;
    const [masterGain, setMasterGain] = React.useState<number>();

    // Set master gain
    useEffect(() => {
        if (!mixer) return;
        setMasterGain(mixer.masterGain.gain.value);
    }, [masterGain, mixer]);

    if (!mixer) {
        return <div>Error: Mixer is not initialized</div>;
    }

    if (!masterGain) {
        return <div>Error master channel not initialized</div>;
    }

    return (

        <div className={'ryd-audio-mixer'}
            style={{ display: 'flex', flexDirection: 'row', gap: '2px', padding: '2px', overflowX: 'scroll' }}
        >
            {tracks.map((track, channelNumber) => (
                <div key={track.id} className="track-control-wrapper">
                    <TrackControl
                        channelNumber={channelNumber}
                        track={track}
                        onUpdate={onUpdate}
                        trackColor={track.trackColor}
                        output={track.output}
                    />
                </div>
            ))}

            <div className="track-control-wrapper">
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'left',
                    gap: '2px',
                    padding: '2px',
                    border: '1px solid #ccc',
                    borderRadius: '2px',
                    backgroundColor: '#f9f9f9'
                }}
                    className={'ryd-instrument-wrapper'}>
                    <h3>Master</h3>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <label>
                            Volume
                            <input
                                className="vertical"
                                type="range"
                                min={0}
                                max={1}
                                step={0.01}
                                value={masterGain}
                                onChange={e => onUpdateMaster({ gain: parseFloat(e.target.value) })}
                            />
                        </label>
                        <VolumeMeter audioNode={mixer.masterGain} />

                    </div>
                </div >
            </div>
        </div>
    );
};